// Bump on every publish; must match backend/routes/release.py
export const RELEASE = { version: 'r2026.10.31-7', name: 'Admin Email Settings (Emergent sender active)' };
